import { render } from "./AddTestCase.vue?vue&type=template&id=9e2139e0"
import script from "./AddTestCase.vue?vue&type=script&lang=js"
export * from "./AddTestCase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__